const constants = {
	LWM_ADMIN_TOKEN_KEY: 'LWM_ADMIN_TOKEN_KEY',
	PAGE_COUNT: 10,
};

export default constants;
